import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Card, CardContent, CardHeader, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material';

import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';
import { DownloadFile } from '../../helpers/DownloadFile';

import { usePages } from '../../hooks/usePages';

import { RootState } from '../../store';
import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { Layout } from "../../components/Layout"

import { DialogExpediente } from '../../dialogs/DialogExpediente';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerEstatus } from '../../connections/catalogos/EstatusConnection';
import { CancelarFechaAudiencia } from '../../connections/audiencias/AgendaConnection';
import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerTipoAudiencias } from '../../connections/catalogos/TipoAudienciaConnection';
import { ObtenerAgendaAudiencias, DescargarInformacionAudiencias } from '../../connections/audiencias/AudienciaConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { AgendaAudienciaProps } from '../../interfaces/audiencias/AudienciaInterface';
import { TipoAudienciaProps } from '../../interfaces/catalogos/TipoAudienciaInterface';
import { ExpedienteProps, defaultExpediente } from '../../interfaces/recepcion/ExpedienteInterface';
import { EstatusProps } from '../../interfaces/catalogos/EstatusInterface';

export const AgendaAudienciasPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingDescargar, setLoadingDescargar] = useState( false );

    const [recordCount, setRecordCount] = useState( 0 );

    const [fecha, setFecha] = useState( '' );
    const [numeroExpediente, setNumeroExpediente] = useState( '' );

    const [tipoAudiencia, setTipoAudiencia] = useState( 0 );
    const [tipoAudienciaArray, setTipoAudienciaArray] = useState<TipoAudienciaProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [estatus, setEstatus] = useState( 0 );
    const [estatusArray, setEstatusArray] = useState<EstatusProps[]>( [] );

    const [rows, setRows] = useState<AgendaAudienciaProps[]>( [] );

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [openCancelar, setOpenCancelar] = useState( false );
    const [idAgendaCancelar, setIdAgendaCancelar] = useState( 0 );
    const [motivoCancelacion, setMotivoCancelacion] = useState( '' );
    const [loadingCancelar, setLoadingCancelar] = useState( false );

    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [expedienteSelected, setExpedienteSelected] = useState<ExpedienteProps>( defaultExpediente );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const esCancelable = ( fechaInicio?: Date ) => {

        if ( !fechaInicio ) return false;

        const manana = moment().add(1, 'days').startOf('day');

        return moment( fechaInicio ).isSameOrAfter( manana );
    }

    const handleAbrirCancelar = ( idAgenda: number ) => {

        setIdAgendaCancelar( idAgenda );
        setMotivoCancelacion( '' );
        setOpenCancelar( true );

    }

    const handleConfirmarCancelar = async () => {

        setLoadingCancelar( true );

        await CancelarFechaAudiencia({ idAgenda: idAgendaCancelar, motivoCancelacion }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setRows( prev => prev.map( r =>
                        r.idAgenda === idAgendaCancelar
                            ? { ...r, idEstatus: 17, estatus: 'Audiencia cancelada', observaciones: motivoCancelacion }
                            : r
                    ));

                    setOpenCancelar( false );
                    setLoadingCancelar( false );

                    dispatch( openSnackbar({ message, variant: 'success' }));
                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }));

                    setLoadingCancelar( false );
                }

            }, 700);

        });

    }

    const handleClear = () => {

        setFiltroAplicado( false );

        setFecha( '' );
        setNumeroExpediente( '' );
        setTipoAudiencia( 0 );
        setAutoridad( 0 );
        setEstatus( 0 );

        setRows( [ ] );
        setRecordCount( 0 );

        resetPage();

    }

    const handleBuscar = async () => {

        setLoadingSearch( true );
        setFiltroAplicado( true );

        setRecordCount( 0 );

        resetPage();
    }

    const handleDescargar = async () => {

        setLoadingDescargar( true );

        await DescargarInformacionAudiencias({
            idAutoridad: autoridad,
            fechaAudiencia: fecha,
            numeroExpediente: numeroExpediente,
            idTipoAudiencia: tipoAudiencia,
            idEstatus: estatus
        }).then( resp => {

            if ( resp ) {

                setTimeout(() => {

                    DownloadFile( `Agenda-Audiencias-${ Date.now() }.xlsx`, resp );

                    setLoadingDescargar( false );

                }, 700);

            }

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAudiencias().then( resp => {
                setTipoAudienciaArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstatus().then( resp => {
                setEstatusArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [ ] );

            await ObtenerAgendaAudiencias( { page, rowsPerPage, idAutoridad: 0, fechaAudiencia: '', numeroExpediente: '', idTipoAudiencia: 0, idEstatus: 0 } ).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRows( [ ] );

            await ObtenerAgendaAudiencias( { page, rowsPerPage, idAutoridad: autoridad, fechaAudiencia: fecha, numeroExpediente: numeroExpediente, idTipoAudiencia: tipoAudiencia, idEstatus: estatus } ).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );
                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ page, rowsPerPage, filtroAplicado, fecha, numeroExpediente, tipoAudiencia, estatus, autoridad ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Consultas' }, { text: 'Agenda de audiencias' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon />} color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>
                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={idMateria} value={idMateria}>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado || materia === 0 }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={idAutoridad} value={idAutoridad}>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label="Fecha"
                                        type="date"
                                        value={ fecha }
                                        onChange={ ( e ) => setFecha( e.target.value ) }
                                        disabled={ filtroAplicado }
                                        slotProps={{
                                            input: {
                                                autoComplete: 'off'
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label='Número de expediente'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        autoComplete='off'
                                        variant='outlined'
                                        value={numeroExpediente}
                                        onChange={(e) => setNumeroExpediente(e.target.value)}
                                        disabled={filtroAplicado}
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 5, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de audiencia</InputLabel>

                                        <Select
                                            label="Tipo de audiencia"
                                            value={ tipoAudiencia }
                                            onChange={ (e) => setTipoAudiencia( e.target.value ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoAudienciaArray.map( ({ idTipoAudiencia, descripcion }) => (
                                                    <MenuItem key={idTipoAudiencia} value={idTipoAudiencia}>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 5, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Estatus</InputLabel>

                                        <Select
                                            label="Estatus"
                                            value={ estatus }
                                            onChange={ (e) => setEstatus( parseInt( e.target.value.toString() ?? '0' ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                estatusArray
                                                .filter( ({ idEstatus }) =>
                                                    idEstatus === 12 ||
                                                    idEstatus === 13 ||
                                                    idEstatus === 14 ||
                                                    idEstatus === 15 ||
                                                    idEstatus === 16
                                                )
                                                .map( ({ idEstatus, descripcion }) => (
                                                    <MenuItem key={idEstatus} value={idEstatus}>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }} textAlign={ 'end' }>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ loadingSearch }
                                        disabled={ fecha === '' && tipoAudiencia === 0 && estatus === 0 && autoridad === 0 && numeroExpediente === '' }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                        sx={{ mt: 1 }}
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'right' }>

                    <Button
                        color='secondary'
                        variant="outlined"
                        sx={{ mt: 1 }}
                        loading={ loadingDescargar }
                        disabled={ rows.length === 0 }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minWidth: 500 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Audiencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Expediente</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Juez(a)</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Secretario(a) de audiencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Sala</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold', textAlign: 'center' }}>Estatus</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows
                                    .map( ( { idAgenda, fechaInicio, fechaFin, numeroExpediente, tipoAudiencia, idEstatus, estatus, juez, secretario, sala, observaciones, expediente }, index ) => (

                                        <TableRow key={index} >

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='subtitle1'>
                                                    { fechaInicio ? moment( fechaInicio ).format( 'DD-MM-YYYY' ) : '' }
                                                </Typography>

                                                <Typography variant='caption' color='text.secondary'>
                                                    { fechaInicio ? moment( fechaInicio ).format( 'HH:mm' ) : '' } - { fechaFin ? moment( fechaFin ).format( 'HH:mm' ) : '' }
                                                </Typography>

                                                <Typography variant='subtitle1' fontWeight={ 'bold' } mt={ 1 }>
                                                    { tipoAudiencia }
                                                </Typography>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => {
                                                        setExpedienteSelected( expediente );
                                                        setOpenDialogExpediente( true )
                                                    }}
                                                >

                                                    { numeroExpediente }
                                                </Button>

                                            </TableCell>

                                            <TableCell> { juez } </TableCell>

                                            <TableCell> { secretario }  </TableCell>

                                            <TableCell sx={{ fontWeight: 'bold' }}>
                                                { sala }
                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Chip
                                                    variant='filled'
                                                    sx={{ fontWeight: 'bold', p: 2 }}
                                                    color={
                                                        idEstatus === 14 ? 'success'
                                                        : idEstatus === 16 ? 'error'
                                                        : idEstatus === 12 ? 'info'
                                                        : 'secondary'
                                                    }
                                                    label={
                                                        <Typography variant='subtitle1' fontWeight={ '600' } fontSize={ 14 }>
                                                            { estatus }
                                                        </Typography>
                                                    }
                                                />

                                                {
                                                    ( idEstatus === 17 && observaciones )
                                                    &&
                                                        <Typography variant='caption' color='text.secondary' display='block' sx={{ mt: 0.5, fontStyle: 'italic' }}>
                                                            { observaciones }
                                                        </Typography>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    (( idEstatus === 12 && esCancelable( fechaInicio ) ) && (administrador || coordinador ))
                                                    &&
                                                        <Tooltip title='Cancelar audiencia'>

                                                            <IconButton
                                                                color='error'
                                                                size='small'
                                                                onClick={ () => handleAbrirCancelar( idAgenda ) }
                                                            >
                                                                <HighlightOffIcon />
                                                            </IconButton>

                                                        </Tooltip>
                                                }

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 100 }}>

                                            <TableCell colSpan={ 8 } align="center">

                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 100 }}>

                                                <TableCell colSpan={ 8 } align="center">

                                                    <CircularProgress size={ 26 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de audiencias: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={[ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ]}
                                        colSpan={ 8 }
                                        count={ recordCount }
                                        rowsPerPage={rowsPerPage}
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogExpediente
                expediente={ expedienteSelected }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openCancelar }
                onClose={ () => {} }
            >

                <DialogTitle> Cancelar audiencia </DialogTitle>

                <DialogContent>

                    <TextField
                        fullWidth
                        multiline
                        rows={ 4 }
                        label='Motivo de cancelación'
                        value={ motivoCancelacion }
                        onChange={ (e) => setMotivoCancelacion( e.target.value ) }
                        disabled={ loadingCancelar }
                        slotProps={{
                            input: { autoComplete: 'off' },
                            inputLabel: { shrink: true }
                        }}
                        sx={{ mt: 1 }}
                    />

                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>

                    <Button
                        variant='text'
                        color='secondary'
                        onClick={  () => setOpenCancelar( false ) }
                        disabled={ loadingCancelar }
                    >
                        Cerrar
                    </Button>

                    <Button
                        variant='contained'
                        color='error'
                        loading={ loadingCancelar }
                        disabled={ motivoCancelacion.trim() === '' }
                        onClick={ handleConfirmarCancelar }
                    >
                        Confirmar cancelación
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}
